module.exports = __webpack_public_path__ + "img/blur360.b4fecd3a.png";